export const LOGIN_REWARDS = [
  { day: 1, emoji: '🧧', name: '功德紅包', description: '增加100次敲擊計數' },
  { day: 2, emoji: '🔮', name: '智慧寶珠', description: '獲得額外成就點數' },
  { day: 3, emoji: '🎭', name: '修行面具', description: '解鎖特殊敲擊效果' },
  { day: 4, emoji: '🏆', name: '成就獎盃', description: '隨機解鎖一個成就' },
  { day: 5, emoji: '🎁', name: '神秘禮盒', description: '獲得驚喜獎勵' },
  { day: 6, emoji: '💰', name: '財富袋', description: '增加財富木魚效果' },
  { day: 7, emoji: '🌟', name: '星光護符', description: '下次敲擊連擊加倍' }
];